import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faYoutubeSquare } from "@fortawesome/free-brands-svg-icons"

export const YoutubeSquare = (props) => {
  return <FontAwesomeIcon faIcon={faYoutubeSquare} {...props} />
}
